import { RequestsApi } from '../../generated/new';

const requestsApi = new RequestsApi();

export default requestsApi;
